/*!
 * STYRKR Welcome Kit v4 — Add kit + free gifts as one cart operation
 */
;(function () {
  document.addEventListener('submit', async function (e) {
    var form = e.target

    if (!form.matches('.wk-cta-form, .wk-ladder__form, .wk-sticky__form')) return

    e.preventDefault()

    try {
      var formData = new FormData(form)
      var kitId = formData.get('id')
      var kitQuantity = parseInt(formData.get('quantity'), 10) || 1

      // 1. Clear cart first
      await fetch('/cart/clear.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
      })

      // 2. Add all items in a single multi-item request
      var response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({
          items: [
            { id: 57260797854078, quantity: 1 }, // GEL30 6 Pack
            { id: 41104324263970, quantity: 2 }, // Clear Bottle
            { id: parseInt(kitId, 10), quantity: kitQuantity }, // Welcome Kit LAST = appears on TOP
          ],
        }),
      })

      if (!response.ok) throw new Error('Failed to add items')

      // 3. Redirect to checkout
      window.location.href = '/checkout'
    } catch (err) {
      console.error('WK cart error:', err)
      form.submit()
    }
  })
})()
